export class LocalStorageConstants {
    public static readonly TokenKey: string = 'tokens';
}